import { getRequest, makeApiCall, postRequest } from 'network/api-client'
import { push } from 'connected-react-router'
import { SagaIterator } from 'redux-saga'
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import * as routes from 'src/constants/appRoutes'
import { CreditCheckResponse, CustomerCreditCheckModel } from 'src/typings/api-models/creditCheck'
import CreditCheckApiRoutes from 'src/typings/api-routes/CreditCheckApiRoutes'
import { CreditCheckResponseType } from 'store/creditCheck'
import actions, { CreditCheckActions } from 'store/creditCheck/actions'
import { getType, isActionOf } from 'typesafe-actions'

function* getCustomerInformation(action: CreditCheckActions): SagaIterator {
  if (isActionOf(actions.getCustomerInformation.request)(action)) {
    const request = getRequest(CreditCheckApiRoutes.getCustomerInformation(action.payload))

    const {res: response, err: error} = yield call(
        () => makeApiCall<string>(request)    
          .then(res => ({ res }))
          .catch(err => ({ err }))
        )
    if (!!response) {
        yield put(actions.getCustomerInformation.success(response))
    } else {
      yield put(actions.getCustomerInformation.failure(error))
      yield put(push(routes.messagePage))
    }
  }
}

function* postCreditCheckForm(action: CreditCheckActions): SagaIterator {
  if (isActionOf(actions.postCreditCheckForm.request)(action)) {
    const request = postRequest<CustomerCreditCheckModel>(CreditCheckApiRoutes.postCreditCheckForm(), action.payload)
    const response = yield call(() => makeApiCall<CreditCheckResponse>(request))
    yield put(actions.postCreditCheckForm.success(response))
    yield fork(shouldRedirect, response)
  }
}
/*tslint:disable:no-any*/
function* shouldRedirect(response: any): SagaIterator {
  switch (response.Result) {
    case CreditCheckResponseType.NOHIT:
      break
    case CreditCheckResponseType.ERROR:
    case CreditCheckResponseType.FAIL:
    case CreditCheckResponseType.HOLD:
    case CreditCheckResponseType.PASS:
    default:
      yield put(push(routes.messagePage))
      break
  }
}
/* tslint:enable no-any */

export default function* sagas(): SagaIterator {
  yield all([
    yield takeLatest(getType(actions.getCustomerInformation.request), getCustomerInformation),
    yield takeLatest(getType(actions.postCreditCheckForm.request), postCreditCheckForm)
  ])
}



// WEBPACK FOOTER //
// ./src/store/creditCheck/sagas.ts